<template>
  <div v-if="isPdfPage" class="pdf-wrapper pdf-touch">
    <router-view />
  </div>
  <template v-else>
  <div v-if="isPublicPage" id="wrapper1" class="public-wrapper">
    <div v-if="!isErrorPage" class="login_index_bg1"></div>
    <div id="contents1" class="flx1">
      <div class="login_index_cnt1">

          <h1 v-if="isPublicPage" class="title1">
            <img
              alt="共創未来ポータル"
              class="dsp-w"
              src="/front/assets/common/img/home_title_img1.png"
            >
            <img
              alt="共創未来ポータル"
              class="dsp-s"
              src="/front/assets/common/img/home_title_img1_sp.png"
            >
          </h1>
          <div class="login_index_body1">
            <router-view />
          </div>
      </div>
    </div>

    <UnauthenticatedFooter />
  </div>

  <div v-else-if="isAuthenticated" id="wrapper1" class="auth-wrapper">
    <Header />

    <div class="auth-body">
      <main id="main-contents">
        <router-view />
      </main>
    </div>

    <AuthenticatedFooter v-if="!hideFooter"/>
    <PhoneFooter v-if="!hideFooter"/>
    <SideMenu @close="sideMenuStore.close" />
    <ScrollTop />
  </div>
  </template>
</template>
<script setup>
import { computed, onMounted, onUnmounted, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useAuthStore } from '@stores/auth'
import { Capacitor } from '@capacitor/core'
import Header from '@parts/Header.vue'
import AuthenticatedFooter from '@parts/AuthenticatedFooter.vue'
import UnauthenticatedFooter from '@parts/UnauthenticatedFooter.vue'
import ScrollTop from '@parts/ScrollTop.vue'
import PhoneFooter from './pages/components/parts/PhoneFooter.vue'
import SideMenu from '@parts/SideMenu.vue'
import { useSideMenuStore } from '@stores/sidemenu'
import { useKeyBoardFooter } from '@functions/useKeyBoardFooter'

useKeyBoardFooter()

const route = useRoute()
const auth = useAuthStore()
const sideMenuStore = useSideMenuStore()
const isPdfPage = computed(() => route.meta.isPdf === true)

/**
 * 認証不要ページ
 */
const publicPaths = [
    '/login'
    , '/error'
    , '/forgot-password'
    , '/forgot-password/complete'
    , '/password/reset'
    , '/reset-password'
    , '/change-password'
]

const isPublicPage = computed(() => {
  // 完全一致またはプレフィックス付きパスで判定
  return publicPaths.some(path => 
    route.path === path || route.path.startsWith(path + '/')
  )
})

const isAuthenticated = computed(() => auth.isAuthenticated)

const isErrorPage = computed(() => route.path.startsWith('/error'))

const hideFooter = computed(() =>
  route.matched.some(record => record.meta.hideFooter)
)

const NATIVE_APP_BODY_CLASS = 'capacitor-native';

const disableZoom = () => {
  const viewport = document.querySelector('meta[name="viewport"]')
  if (viewport) {
    viewport.setAttribute(
      'content',
      'width=device-width, initial-scale=1, maximum-scale=1, viewport-fit=cover, user-scalable=no'
    )
  }
}

const preventGesture = (event) => {
  if (event.cancelable) {
    event.preventDefault();
  }
}

let nativeGestureCleanup = null;

const enableNativeZoomGuards = () => {
  document.body.classList.add(NATIVE_APP_BODY_CLASS);
  disableZoom();

  document.addEventListener('gesturestart', preventGesture, { passive: false });
  document.addEventListener('gesturechange', preventGesture, { passive: false });
  document.addEventListener('gestureend', preventGesture, { passive: false });

  nativeGestureCleanup = () => {
    document.body.classList.remove(NATIVE_APP_BODY_CLASS);
    document.removeEventListener('gesturestart', preventGesture);
    document.removeEventListener('gesturechange', preventGesture);
    document.removeEventListener('gestureend', preventGesture);
    nativeGestureCleanup = null;
  };
};

const syncInitialVh = () => {
  document.documentElement.style.setProperty('--initial-vh', `${window.innerHeight}px`);
};

let pdfPageResizeHandler = null;

const startPdfPageResizeSync = () => {
  syncInitialVh();
  if (pdfPageResizeHandler) {
    return;
  }

  pdfPageResizeHandler = () => {
    syncInitialVh();
  };
  window.addEventListener('resize', pdfPageResizeHandler);
};

const stopPdfPageResizeSync = () => {
  if (!pdfPageResizeHandler) {
    return;
  }

  window.removeEventListener('resize', pdfPageResizeHandler);
  pdfPageResizeHandler = null;
};

onMounted(() => {
  // キーボード表示でビューポートが縮んでも背景サイズを維持するため起動時の高さを固定
  syncInitialVh();

  if (Capacitor.isNativePlatform()) {
    enableNativeZoomGuards();
  }
})

onUnmounted(() => {
  stopPdfPageResizeSync();
  nativeGestureCleanup?.();
})

// bodyクラス同期をApp.vueに集約
watch(isPdfPage, (isPdf) => {
  document.body.classList.toggle('pdf-page-active', isPdf)
  if (isPdf) {
    startPdfPageResizeSync();
    return;
  }

  stopPdfPageResizeSync();
}, { immediate: true })

watch(() => sideMenuStore.isSideMenuOpen, (open) => {
  document.body.classList.toggle('com_app_menu_open', open)
  if (!open) document.body.style.marginRight = ''
})
</script>

<style>
html:has(body.pdf-page-active),
body.pdf-page-active,
body.pdf-page-active #app {
  height: 100%;
  min-height: var(--initial-vh, 100dvh);
  overflow: hidden;
}

body.pdf-page-active {
  background: #fff;
}

.pdf-touch {
  display: flex;
  flex-direction: column;
  width: 100%;
  min-height: var(--initial-vh, 100dvh);
  height: 100%;
  overflow: hidden;
}

.pdf-touch > * {
  flex: 1;
  min-height: 0;
}
</style>
